import { joinPath } from '../../core/utils';
import type { PowerPolicyBlockOptions, PowerPolicyPaths } from './types';

export function resolvePowerPolicyPaths(prefix: string, options?: PowerPolicyBlockOptions): PowerPolicyPaths {
  return {
    powerPolicy: joinPath(prefix, 'powerPolicy'),
  };
}
